// extracted by mini-css-extract-plugin
export default {"div":"Dashboard_div__VMT22","img":"Dashboard_img__JHD2b","chart":"Dashboard_chart__PPQBc"};